var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading-overlay" }, [_vm._m(0)])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "p-3" }, [
      _c("div", { staticClass: "d-flex justify-content-between mb-3" }, [
        _c("h3", [_vm._v("Update Kategori & Cara Bayar")]),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "btn btn-secondary", on: { click: _vm.openHistory } },
          [
            _c("i", { staticClass: "fa fa-history" }),
            _vm._v(" History\n            "),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "card mb-3" }, [
        _c("div", { staticClass: "card-header bg-primary text-white" }, [
          _vm._v("\n                Pencarian Pasien\n            "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("label", [_vm._v("Medrec / Nama")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.filter.search,
                    expression: "filter.search",
                  },
                ],
                staticClass: "form-control",
                domProps: { value: _vm.filter.search },
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.getAllPasien.apply(null, arguments)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.filter, "search", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2 d-flex align-items-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.getAllPasien },
                },
                [
                  _vm._v(
                    "\n                            Cari\n                        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "modal fade", attrs: { id: "modal-detail" } }, [
        _c("div", { staticClass: "modal-dialog modal-xl" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.detail_search,
                    expression: "detail_search",
                  },
                ],
                staticClass: "form-control mb-3",
                attrs: { placeholder: "Cari Regno" },
                domProps: { value: _vm.detail_search },
                on: {
                  input: [
                    function ($event) {
                      if ($event.target.composing) return
                      _vm.detail_search = $event.target.value
                    },
                    _vm.filterRegno,
                  ],
                },
              }),
              _vm._v(" "),
              _c("table", { staticClass: "table table-bordered" }, [
                _vm._m(3),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.detail_filtered, function (item) {
                    return _c("tr", { key: item.Regno }, [
                      _c("td", [_vm._v(_vm._s(item.Regno))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.Regdate))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.kategori_total))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.carabayar_total))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.total))]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-warning btn-sm",
                            on: {
                              click: function ($event) {
                                return _vm.openUpdate(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                                            Update\n                                        "
                            ),
                          ]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal fade", attrs: { id: "modal-update" } }, [
        _c("div", { staticClass: "modal-dialog modal-lg" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(4),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "mb-2" }, [
                _c("label", [_vm._v("Regno")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.regno,
                      expression: "form.regno",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { readonly: "" },
                  domProps: { value: _vm.form.regno },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "regno", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _c("label", [_vm._v("Kategori Lama")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.kategori_lama,
                      expression: "form.kategori_lama",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { readonly: "" },
                  domProps: { value: _vm.form.kategori_lama },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "kategori_lama", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _c("label", [_vm._v("Cara Bayar Lama")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.kdcbayar_lama,
                      expression: "form.kdcbayar_lama",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { readonly: "" },
                  domProps: { value: _vm.form.kdcbayar_lama },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.form, "kdcbayar_lama", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _c("label", [_vm._v("Kategori Baru")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.kategori,
                        expression: "form.kategori",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.form,
                            "kategori",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                        _vm.getCaraBayar,
                      ],
                    },
                  },
                  _vm._l(_vm.kategori_list, function (k) {
                    return _c(
                      "option",
                      { key: k.KdKategori, domProps: { value: k.KdKategori } },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(k.NmKategori) +
                            "\n                                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "mb-2" }, [
                _c("label", [_vm._v("Cara Bayar Baru")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.kdcbayar,
                        expression: "form.kdcbayar",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "kdcbayar",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  _vm._l(_vm.carabayar_list, function (c) {
                    return _c(
                      "option",
                      { key: c.KdCbayar, domProps: { value: c.KdCbayar } },
                      [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(c.NMCbayar) +
                            "\n                                "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c(
                "table",
                { staticClass: "table table-bordered" },
                [
                  _vm._l(_vm.preview, function (i) {
                    return _c("tr", { key: i.table }, [
                      _c("td", [_vm._v(_vm._s(i.table))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(i.count))]),
                    ])
                  }),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Total")]),
                    _vm._v(" "),
                    _c("th", [_vm._v(_vm._s(_vm.grand_total))]),
                  ]),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  on: { click: _vm.saveUpdate },
                },
                [
                  _vm._v(
                    "\n                            Simpan\n                        "
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal fade", attrs: { id: "modal-history" } }, [
        _c("div", { staticClass: "modal-dialog modal-xl" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _c("table", { staticClass: "table table-bordered" }, [
                _vm._m(6),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.history, function (h) {
                    return _c("tr", { key: h.id }, [
                      _c("td", [_vm._v(_vm._s(h.tanggal_update))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(h.medrec))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(h.regno))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(h.kategori_lama))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(h.kategori_baru))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(h.kdcbayar_lama))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(h.kdcbayar_baru))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(h.nama))]),
                      _vm._v(" "),
                      _c("td", [
                        h.rollback_at
                          ? _c("span", { staticClass: "badge bg-success" }, [
                              _vm._v("Rollback"),
                            ])
                          : _c("span", { staticClass: "badge bg-warning" }, [
                              _vm._v("Active"),
                            ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        !h.rollback_at
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-danger btn-sm",
                                on: {
                                  click: function ($event) {
                                    return _vm.rollback(h)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                            Rollback\n                                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading-content" }, [
      _c("div", { staticClass: "spinner-border text-primary" }),
      _vm._v(" "),
      _c("div", { staticClass: "mt-3" }, [_vm._v("Mohon tunggu...")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header bg-primary text-white" }, [
        _vm._v("Data Pasien"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table-data" } }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", [_vm._v("Detail Regno")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: { "data-bs-dismiss": "modal" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Regno")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tanggal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Kategori")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cara Bayar")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Action")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", [_vm._v("Update Kategori & Cara Bayar")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: { "data-bs-dismiss": "modal" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", [_vm._v("History Update")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: { "data-bs-dismiss": "modal" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Tanggal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Medrec")]),
        _vm._v(" "),
        _c("th", [_vm._v("Regno")]),
        _vm._v(" "),
        _c("th", [_vm._v("Kategori Lama")]),
        _vm._v(" "),
        _c("th", [_vm._v("Kategori Baru")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cara Bayar Lama")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cara Bayar Baru")]),
        _vm._v(" "),
        _c("th", [_vm._v("User")]),
        _vm._v(" "),
        _c("th", [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", [_vm._v("Action")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }